import React, { useState } from "react"
import ExtraFacilityEdit from './components/ExtraFacilityEdit'
import ExtraFacilityView from './components/ExtraFacilityView'

const ExtraFacilities = (props: any) => {
    const [editFlag, setEditFlag] = useState(false)
    const facilitydata = { ...props.allAPIdata.meetingrooms.extrafacility, ...{ meetingroomsid: props.allAPIdata.meetingrooms.meetingroomsid, meetingroomslangid: props.allAPIdata.meetingrooms.meetingroomslangid } }
    const [facilityData, setFacilityData] = useState<any>(facilitydata)

    return (
        <div>
            {editFlag ? 
                <ExtraFacilityEdit 
                    facilityData={facilityData} 
                    setFacilityData={setFacilityData} 
                    setOneNavDisabled={props.setOneNavDisabled} 
                    setEditFlag={setEditFlag} 
                /> 
                :
                <ExtraFacilityView 
                    facilityData={facilityData} 
                    setOneNavDisabled={props.setOneNavDisabled} 
                    setEditFlag={setEditFlag} 
                />
            }
        </div>
    )
}

export default ExtraFacilities
